import React from "react";
import "./Qrcode.css";

const Qrcode = () => {
  const copyLink = () => {
    const link = "http://localhost:3000/qrcode";
    navigator.clipboard.writeText(link).then(() => {
      alert("Link copiado para a área de transferência!");
    });
  };

  return (
    <div className="container">
      <div className="logo">
        <img src={require("../../../assets/notifylconecta.png")} alt="Logo Notify" />
      </div>
      <div className="content">
        <div className="instructions">
          <h1 style={{ fontSize: "20px", color: "#525252", marginBottom: "16px" }}>Conecte seu WhatsApp</h1>
          <p style={{ fontSize: "16px", color: "#737373", marginBottom: "24px" }}>
            Para usar o WhatsApp no seu computador:
          </p>
          <ol style={{ textAlign: "left", paddingLeft: "20px", color: "#525252" }}>
            <li style={{ marginBottom: "8px" }}>Abra o WhatsApp no seu telefone.</li>
            <li style={{ marginBottom: "8px" }}>Toque em <strong>Mais opções</strong> ou <strong>Configurações</strong> no iPhone.</li>
            <li style={{ marginBottom: "8px" }}>Toque em <strong>Dispositivos conectados</strong>.</li>
            <li style={{ marginBottom: "8px" }}>Toque em <strong>Conectar um dispositivo</strong>.</li>
            <li>Escaneie o QR Code exibido nesta página.</li>
          </ol>
          <div className="copy-link" style={{ marginTop: "16px" }}>
            <input
              id="page-link"
              type="text"
              value="http://localhost:3000/qrcode"
              readOnly
              style={{
                width: "80%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                marginRight: "8px",
              }}
            />
            <button
              onClick={copyLink}
              style={{
                padding: "8px 16px",
                backgroundColor: "#25D366",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Copiar Link
            </button>
          </div>
        </div>
        <div className="qr-code">
          <div>
            {/* QR Code provisório gerado dinamicamente */}
            <img
              src="https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=ConectarWhatsApp"
              alt="QR Code"
            />
            <div className="account-info">
              <p>Conta: João Silva</p>
              <p>Número: +55 11 91234-5678</p>
            </div>
            <div className="pulsing-icon"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Qrcode;